if (!customElements.get('tabs-nav')) {
  customElements.define('tabs-nav', class TabsNav extends HTMLElement {
    constructor() {
      super();
      this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"));
      this.buttons.forEach((button) => button.addEventListener("click", () => this.selectButton(button)));

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => this.selectButton(event.target));
      }
    }

    get selectedButton() {
      return this.buttons.find((button) => button.getAttribute("aria-expanded") === "true");
    }

    selectButton(button) {
      if (!this.buttons.includes(button) || this.selectedButton === button) {
        return;
      }

      const from = document.getElementById(this.selectedButton.getAttribute("aria-controls"));
      const to = document.getElementById(button.getAttribute("aria-controls"));
      from.hidden = true;
      to.hidden = false;

      this.selectedButton.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-expanded", "true");
    }
  })
}